import SelectBox from 'devextreme-react/select-box';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import DoughnutChart from '../../common/charts/Doughnut-chart/DoughnutChart';
import { MarsApiService as api } from '../../../api/mars-api-service';
import { MarsApiConfig as apiConfig } from '../../../api/mars-api-config';
import { useLoaderContext } from '../../../contexts/LoaderContext';
import { IOptionvalue } from '../../../types/master-data';
import { GadgetsTimePeriod } from '../../../enums/gadgets-time-period-enum';
import { Button } from 'devextreme-react/button';
import icons from '../../../components/common/icons/icons';
import Popover from 'devextreme-react/popover';
import { useTranslation } from 'react-i18next';
import { useResize } from '../../../hooks/useResize';
import { getOPtionValueByType } from '../../../services/master-data-service';
import { OptionTypes } from '../../../enums/option-type-enum';
export default function VetByStatusGadget() {
  const [vetByStatus, setVetByStatus] = useState<any[]>([]);
  const [gadgetsTimePeriod, setGadgetsTimePeriod] = useState<any[]>([]);
  const { setIsLoading } = useLoaderContext();
  const [format, setFormat] = useState<any>();
  const [showExportPopover, setShowExportPopover] = useState(false);

  const exportPopupAttributes = useMemo(() => {
    return {
      id: 'elementId',
      class: 'm-l-dashboard__chart-export',
      'data-testid': 'rolePopover',
    };
  }, []);

  const { t } = useTranslation();

  const fileFormats = [
    {
      id: 1,
      name: 'PNG File',
      value: 'png',
    },
    {
      id: 2,
      name: 'JPEG File',
      value: 'jpeg',
    },
    {
      id: 3,
      name: 'PDF File',
      value: 'pdf',
    },
    {
      id: 4,
      name: 'SVG File',
      value: 'svg',
    },
  ];

  const getVetByStatusTimePeriod = async (timePeriod: string) => {
    await api
      .get(
        { url: apiConfig.vetByStatus, params: { timePeriod: timePeriod } },
        setIsLoading
      )
      .then((data: any) => {
        const vets = data.labelsAndCount.slice();
        setVetByStatus(vets);
      });
  };

  const getGadgetsTimePeriod = async () => {
    await getOPtionValueByType(OptionTypes.GadgetsTimePeriod)?.then(
      (res: IOptionvalue[]) => {
        const data = res ? JSON.parse(JSON.stringify(res)) : [];
        const fromIndex = data?.findIndex((x: any) => x?.isDefault == true);
        const element = data?.splice(fromIndex, 1)[0];
        const toIndex = 0;
        data?.splice(toIndex, 0, element);
        setGadgetsTimePeriod(data);
      }
    );
  };

  const [vetBystatusOption, setVetByStatusOption] = useState(
    gadgetsTimePeriod[0]?.optionValueCode
  );

  const chartRef: any = useRef();

  const chartConfig = {
    argumentField: 'label',
    valueField: 'count',
    type: 'doughnut',
    format: format,
    ref: chartRef,
    export: {
      enabled: false,
      format: format,
    },
  };

  const setDataSource = () => {
    if (vetBystatusOption == GadgetsTimePeriod.Week) {
      getVetByStatusTimePeriod(GadgetsTimePeriod.Week);
    } else if (vetBystatusOption == GadgetsTimePeriod.Month) {
      getVetByStatusTimePeriod(GadgetsTimePeriod.Month);
    } else if (vetBystatusOption == GadgetsTimePeriod.Quarter) {
      getVetByStatusTimePeriod(GadgetsTimePeriod.Quarter);
    } else if (vetBystatusOption == GadgetsTimePeriod.HalfYear) {
      getVetByStatusTimePeriod(GadgetsTimePeriod.HalfYear);
    } else {
      getVetByStatusTimePeriod(GadgetsTimePeriod.Year);
    }
  };

  const onCLickExport = (format: any) => {
    chartRef?.current.instance?.exportTo(t('labels.vetsByStatus'), format);
  };

  useEffect(() => {
    if (vetBystatusOption) {
      setDataSource();
    }
  }, [vetBystatusOption]);

  useMemo(() => {
    if (gadgetsTimePeriod && gadgetsTimePeriod.length > 0) {
      setVetByStatusOption(gadgetsTimePeriod[0].optionValueCode);
    }
  }, [gadgetsTimePeriod]);

  useEffect(() => {
    getGadgetsTimePeriod();
  }, []);

  const { isMobileResolution } = useResize();
  const [position, setPosition] = useState<any>('bottom');
  useEffect(() => {
    if (isMobileResolution) {
      setPosition('left');
    } else {
      setPosition('bottom');
    }
  }, [isMobileResolution]);

  return (
    <div>
      {gadgetsTimePeriod && gadgetsTimePeriod.length > 0 && (
        <div className="row">
          <div className="col-sm-4 col-md-5 col-lg-6 col-xl-4 col-6">
            <div className="m-c-form-group mb-btm-space">
              <SelectBox
                className="m-c-input-control m-c-select-box"
                placeholder="Select option type"
                dataSource={gadgetsTimePeriod}
                defaultValue={gadgetsTimePeriod[0].optionValueCode}
                searchEnabled
                valueExpr="optionValueCode"
                displayExpr="optionValueText"
                onValueChanged={(e) => setVetByStatusOption(e.value)}
              />
            </div>
          </div>
          <div
            className="col-sm-8 col-md-7 col-lg-6 col-xl-8 
          col-6 d-flex"
          >
            <div className="ml-dashboard-export">
              <Button
                id="linkVetStatus"
                className="app-c-btn app-c-btn--secondary m-c-icon-inside-secondary-button"
                aria-label="Export-btn"
                onClick={() => setShowExportPopover(true)}
              >
                <div className="m-c-icon-inside-btn" data-testid="export-all">
                  <icons.download />
                </div>
              </Button>
              <Popover
                target="#linkVetStatus"
                position={position}
                width={132}
                visible={showExportPopover}
                wrapperAttr={exportPopupAttributes}
                closeOnOutsideClick={true}
                onHiding={() => setShowExportPopover(false)}
              >
                <ul className="ml-expport-list">
                  {fileFormats.map((role: any, index: any) => {
                    return (
                      <li key={index} onClick={() => onCLickExport(role.value)}>
                        {role.name}
                      </li>
                    );
                  })}
                </ul>
              </Popover>
            </div>
          </div>
        </div>
      )}
      <div className="row">
        <DoughnutChart
          dataSource={vetByStatus}
          pieChartConfig={chartConfig}
          chartRef={chartRef}
        />
      </div>
    </div>
  );
}
